import { render, staticRenderFns } from "./CarItemInfo.vue?vue&type=template&id=0e16bf03&scoped=true"
import script from "./CarItemInfo.vue?vue&type=script&lang=js"
export * from "./CarItemInfo.vue?vue&type=script&lang=js"
import style0 from "./CarItemInfo.vue?vue&type=style&index=0&id=0e16bf03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16bf03",
  null
  
)

export default component.exports